import Router from "next/router";
import {
  generatePath,
  isLocalURL,
  concatenateQueryParams,
} from "@gonoodle/gn-universe-utils";
import { ROUTE_PATHS, SPOTLIGHT_TYPES } from "../constants";
import BugsnagClient from "./bugsnag";

export const redirectTo = (location) => (res, opts = { paramString: "" }) => {
  const { paramString } = opts;
  if (res) {
    res.writeHead(302, { Location: location + paramString });
    res.end();
    res.finished = true;
  } else if (/^\/.*/.test(location)) {
    Router.replace(location + paramString);
  } else {
    window.location.assign(location + paramString);
  }
};

export const generateSpotlightPathByType = (destinationType, params = {}) => {
  const DESTINATION = {
    [SPOTLIGHT_TYPES.VIDEO]: ROUTE_PATHS.VIDEOS,
    [SPOTLIGHT_TYPES.ACTIVITY]: ROUTE_PATHS.ACTIVITIES,
    [SPOTLIGHT_TYPES.TAG]: ROUTE_PATHS.TAGS,
  };

  if (DESTINATION[destinationType]) {
    const path = generatePath(DESTINATION[destinationType], params);
    return path;
  }
  return null;
};

export const pushExternal = (
  href,
  linkParams,
  as,
  options = { scroll: true, shallow: false },
) => {
  if (isLocalURL(href)) {
    BugsnagClient.notify(new Error(`pushExternal have invalid href: ${href}`));
    Router.push(href, as, options);
  } else {
    Router.replace(
      concatenateQueryParams("/external-link-disclaimer", {
        ...linkParams,
        href,
      }),
      as,
      options,
    );
  }
};
